import { useState } from 'react'
import { useAuthContext } from './useAuthContext'
import { withSessionExpiry } from '../config/session'

export const useLogin = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(null)
    const { dispatch } = useAuthContext()

    const login = async (email, password) => {
      setIsLoading(true);
      setError(null);
  
      const response = await fetch('https://quibly.onrender.com/api/user/login', { //https://quantumix.onrender.com/api/user/login
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({email, password})
      });
  
      const json = await response.json();
  
      if (!response.ok) {
          setIsLoading(false);
          setError(json.error);
          return false;  // Indicate failure
      }
  
      const user = withSessionExpiry(json);

      localStorage.setItem('user', JSON.stringify(user));
      dispatch({ type: 'LOGIN', payload: user });
  
      setIsLoading(false);
      return true;  // Indicate success
  }

      return { login, isLoading, error };
}
